import {
  PortableText,
  type PortableTextReactComponents,
} from '@portabletext/react'
import clsx from 'clsx'
import type { FC } from 'react'

import type { RichTextSectionProps } from '@/types/components/section-rich-text'
import { Section } from '../Section'
import { ButtonGroup } from './ButtonGroup'
import { ResponsiveImage } from './ResponsiveImage'
import { RichTextBlock } from './RichTextBlock'
import { Table } from './Table'
import './base.scss'

const portableTextComponents: Partial<PortableTextReactComponents> = {
  block: RichTextBlock,
  types: {
    'component.buttonGroup': ButtonGroup,
    'component.responsiveImage': ResponsiveImage,
    'component.table': Table,
  },
  marks: {
    alignLeft: ({ children }) => children,
  },
}

const richTextClass = ['section-rich-text']

export const SectionRichText: FC<RichTextSectionProps> = ({
  hasWrapper = true,
  content,
}) => {
  const {
    _id,
    theme,
    verticalPaddingSize,
    content: portableTextContent,
  } = content

  return (
    <Section
      hasWrapper={hasWrapper}
      theme={theme}
      size={verticalPaddingSize}
      id={_id}
    >
      <div className={clsx(richTextClass)}>
        <PortableText
          value={portableTextContent}
          components={portableTextComponents}
        />
      </div>
    </Section>
  )
}
